import React, { Component } from "react";
import { Row, Label, Col, Breadcrumb, BreadcrumbItem } from "reactstrap";
import UserIcon1 from "../../../assets/user-image-plc/User_Icon_1.svg";
import UserIcon2 from "../../../assets/user-image-plc/User_Icon_2.svg";
import UserIcon3 from "../../../assets/user-image-plc/User_Icon_3.svg";
import UserIcon4 from "../../../assets/user-image-plc/User_Icon_4.svg";
import UserIcon5 from "../../../assets/user-image-plc/User_Icon_5.svg";
import "./OfficeMateProfile.css";
import axios from "../../../axios";
import * as url from "../../../utils/url";
import ProfilePage from "../../user/ProfilePage";

export default class OfficeMateProfileMobilePopup extends Component {
  constructor(props) {
    super(props);
    this.state = {
      officeMate: undefined,
      profilePicSrcIndex: 0,
      menu: 1,
    };
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    let id = this.props.officematePopupId;
    let org = this.props.officematePopupOrgId;

    this.getUserDetails(id, org);
  }

  navigateToOfficeMates = () => {
    this.props.history.push("/home/users");
  };

  getUserDetails = (id, org) => {
    let that = this;
    axios.get(url.getUserProfile(id, org)).then(response => {
      that.setState({ officeMate: response.data.data });
    });
  };

  renderContent = () => {
    let { officeMate, menu } = this.state;
    if (officeMate && officeMate._id) {
      return (
        <ProfilePage
          {...this.state.officeMate}
          member={this.state.officeMate}
          menu={menu}
          profileEditSuccsess={this.handleProfileUpdateSuccess}
          profilePopupMemberGrp={true}
        />
      );
    } else {
      return <div> Loading... </div>;
    }
  };

  render() {
    let {
      firstName,
      lastName,
      title,
      email,
      dIRole,
      profilePic,
      profilePicSrcIndex,
    } = { ...this.state.officeMate };
    let offcemateName =
      (firstName ? firstName : "") +
      (lastName ? (firstName ? " " + lastName : lastName) : "");
    let userPicPlaceholders = [
      UserIcon1,
      UserIcon2,
      UserIcon3,
      UserIcon4,
      UserIcon5,
    ];
    return this.renderContent();
  }
}
